export default __webpack_public_path__ + "static/media/BG1-1.3959ec83.jpg";